
import { Prop, Vue } from "vue-property-decorator";
import Component from "vue-class-component";
import { ISolCustomerOrderContainer } from "@/entities";
@Component({
  name: "detail-container",
})
export default class DetailContainer extends Vue {
  @Prop({ required: true })
  container!: ISolCustomerOrderContainer[];
  constructor() {
    super();
  }
}
